class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.syncOpenState = this.syncOpenState.bind(this);

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close(),
    );
    this.detailsContainer.addEventListener('toggle', this.syncOpenState);
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  connectedCallback() {
    if (!this.isOpen()) return;

    /* defer 読込前に <details> が先に開いた場合でも、upgrade 後に body 状態と閉じる導線を復元する */
    this.syncOpenState();
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  syncOpenState() {
    const isOpen = this.isOpen();
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);

    if (isOpen) {
      document.body.addEventListener('click', this.onBodyClickEvent);
      document.body.classList.add('overflow-hidden');
    } else {
      document.body.removeEventListener('click', this.onBodyClickEvent);
      document.body.classList.remove('overflow-hidden');
    }
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay'))
      this.close(false);
  }

  open(event) {
    event.target.closest('details').setAttribute('open', true);
    this.syncOpenState();

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])'),
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    this.syncOpenState();
  }
}

customElements.define('details-modal', DetailsModal);
